export const posts = [
    {
        slug: 'convert-word-to-pdf-without-losing-formatting',
        title: 'How to Convert Word to PDF Without Losing Formatting',
        description:
            'Practical guide to producing clean PDFs from Word documents — fonts, layouts, tables, headers, and hyperlinks included.',
        date: '2026-03-12',
        readingTime: '8 min read',
        excerpt:
            'Fonts shift. Tables break. Headers disappear. Here is how to convert Word to PDF so the output looks exactly like the original — and what tools are reliable when the document is complicated.',
    },
    {
        slug: 'pdf-compression-lossless-vs-lossy',
        title: 'PDF Compression Explained: Lossless vs Lossy',
        description:
            'Why some PDFs shrink dramatically and others barely budge. A hands-on guide to choosing the right PDF compression technique.',
        date: '2026-03-18',
        readingTime: '9 min read',
        excerpt:
            'A 30 MB PDF becomes 3 MB with one tool and 28 MB with another. That is not magic — that is the difference between lossless and lossy compression, and knowing which to use matters.',
    },
    {
        slug: 'client-side-document-processing-is-safer',
        title: 'Why Client-Side Document Processing Is Safer',
        description:
            'Every online converter that uploads your file introduces a privacy risk. Here is why browser-based tools exist and how they work under the hood.',
        date: '2026-03-25',
        readingTime: '7 min read',
        excerpt:
            'When you upload a contract to convert it, that contract exists on a server you do not control. Here is the technical and practical case for keeping document processing in your browser.',
    },
    {
        slug: 'pdf-to-word-what-actually-works',
        title: 'PDF to Word: What Actually Works (and What Doesn&rsquo;t)',
        description:
            'Honest evaluation of PDF-to-Word conversion. What you can reasonably expect from any tool, and how to get the cleanest output.',
        date: '2026-04-02',
        readingTime: '10 min read',
        excerpt:
            'No converter can perfectly reverse a PDF into a Word document. The reason is structural — and once you understand it, you will know how to pick the right approach for every job.',
    },
    {
        slug: 'complete-guide-to-pdf-file-security',
        title: 'The Complete Guide to PDF File Security',
        description:
            'Passwords, permissions, redaction, digital signatures, and what "secure" really means for a PDF in 2026.',
        date: '2026-04-10',
        readingTime: '11 min read',
        excerpt:
            'People use PDFs for contracts, medical records, and banking statements — and then treat them like they are automatically secure. Here is what a PDF actually protects, what it does not, and the checklist for sharing one safely.',
    },
];

export const postBySlug = (slug) => posts.find((p) => p.slug === slug);
